import {convertDateTimeToFormat} from "../../utils/DateUtils";

export class MaterialDateLocaleProvider {

    static instance = ['$mdDateLocaleProvider', MaterialDateLocaleProvider];

    constructor(datesProiveder: angular.material.IDateLocaleProvider) {
        datesProiveder.formatDate = (date: Date) => convertDateTimeToFormat(date, '');
    }
}